import axios from "axios";

export const listOfferings = (cursor, limit, success, failure) => {
    let url = "/api/v1/offering/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const createOffering = (offering, success, failure) => {
    const url = `/api/v1/offering/`;

    axios.post(url, {
        nodeId: offering.nodeId,
        category: offering.category,
        type: offering.type,
        amount: {
            dollars: offering.dollars,
            cents: offering.cents,
        },
        date: offering.date,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const updateOffering = (offeringId, offering, success, failure) => {
    const url = `/api/v1/offering/${offeringId}/`;

    axios.put(url, {
        nodeId: offering.nodeId,
        category: offering.category,
        type: offering.type,
        amount: {
            dollars: offering.dollars,
            cents: offering.cents,
        },
        date: offering.date,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const deleteOffering = (offeringId, success, failure) => {
    const url = `/api/v1/offering/${offeringId}/`;

    axios.delete(url)
    .then(response => {
        success(offeringId);
    })
    .catch(err => {
        failure(err);
    });
};
